
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Michael «Mike» Hersberger und Stefan «Rubi» Ruprecht sind die zwei Gesichter
  hinter Taberna Gastro-Kultur, die vier Lokale führen: das Ringgenberg, das
  Café des Pyrénées, die Marzilibrücke und die Dampfzentrale. Aufgebaut wurden
  die Restaurants von der Berner Werbeagentur Contexta und dem heutigen
  Weinimperium Hess des Berner Unternehmers Donald Hess. Zum Portfolio gehörten
  damals aber noch mehr: das Fischerstübli, das Zähringer, der Obstberg und das
  Bierhübeli. Michael Hersberger und Stefan Ruprecht führten damals die
  Marzilibrücke.
    </p>
    <p>
  Als sich die Gründer Ende 1999 zurückziehen wollten, ergab sich die
  Gelegenheit für die beiden, die Taberna, welche mittlerweile auf noch zwei
  Betriebe geschrumpft war, zu übernehmen. Sie hatten 1985 ihre AG Taberna
  gegründet. «Die Marzilibrücke kannten wir ja gut, wir wussten, worauf wir uns
  einliessen. Beim Ringgenberg waren wir sicher, dass wir daraus ein
  funktionierendes Restaurant machen konnten», sagt Stefan Ruprecht heute. Das
  «Ringgi» wurde damals noch «Gnagihalle» genannt. Hier kehrte man ein, um zu
  spielen und zu trinken. Taberna brach mit der Tradition und fing an, Essen zu
  kochen. 2004 bewarben sie sich für die Dampfzentrale mit einem Konzept.
    </p>
    <Image file={require('images/taberna_2.jpg')} source='In den zwei Lokalen an der Aare kommen im Sommer 350 Aussenplätze dazu. Bild: Raphael Moser' mdxType="Image" />
    <p>
  Es dauerte noch bis 2012, bis sie ihr zweites Restaurant an der Aare
  übernehmen konnten. «Die Chance, das legendäre Café Pyrénées zu übernehmen,
  kam zur Unzeit», sagt Ruprecht. Gerade hatten sie all ihr Geld in den Umbau
  der «Dampfere» gesteckt, wussten aber, dass sich die Chance lange nicht mehr
  bieten würde. Nach zwei Jahren Bedenkzeit schlugen sie zu. «Beim Pyri waren
  wir uns nicht sicher, ob wir damit in die schwarzen Zahlen kommen können.»
  Nach zwei Jahren Betriebszeit wurde das in die Jahre gekommene «Pyri» 2018
  umgebaut. «Danach schafften wir es, die Stammgäste nicht zu verlieren und
  neues Publikum anzusprechen.»
    </p>
    <p>
  Alle vier Lokale werden jeweils von zwei Geschäftsführern geführt, wobei
  Ruprecht und Hersberger die Dampfzentrale selber managen. Alle Geschäftsführer
  von Taberna sind gewinnbeteiligt. Im Sommer vergrössert sich die zu bewirtende
  Fläche massiv: In den Gärten der beiden Betriebe an der Aare kommen 350 Plätze
  dazu, oben in der Stadt bewirten sie das Ringgenpärkli mit 100 Plätzen, und
  die Kunsthallenbar bei der Kirchenfeldbrücke wird noch bis 2021 betrieben. Zum
  Umsatz äussert sich Taberna nicht.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;